module.exports = __webpack_public_path__ + "img/catalogue8.82ac2565.png";